import { HomeStatus } from "../types/home.type";
import ApiService from "./apiService";

const endpoint = "/api/v1/negocios/home";

class HomeService extends ApiService {
  getStatus() {
    return this.get<HomeStatus>(`${endpoint}/status`, {
      negocioActivo: true,
    });
  }

  updateCerradoMomentaneo(cerrado: boolean) {
    return this.post<{ cerrado: boolean }>(
      `${endpoint}/cerrar-momentaneamente`,
      { cerrado },
      {
        negocioActivo: true,
      }
    );
  }
}

const homeService = new HomeService();
export default homeService;
